<template>
  <GeneralLink
    :link="links"
    text=""
    _type="generalLink"
  >
    <div
      :class="{
        'customer-home-card relative mb-10px rounded-5px bg-www-color-neutral-off-white px-4 py-5 transition-all duration-300 ease-in-out hover:bg-www-color-neutral-very-light': true,
        'after:absolute after:right-5 after:h-6 after:w-6 after:-translate-y-1/2 after:rounded-50% after:content-[\'\']': true,
      }"
      :style="`--rightArrowImageSrc: url(${rightArrowImageSrc})`"
    >
      <h3
        :class="{
          'text-lg font-bold leading-3 text-www-color-neutral-medium-dark': true,
        }"
      >
        {{ title }}
      </h3>
      <p
        :class="{
          'hidden h-9 pt-2 text-13px font-medium leading-4 text-www-color-neutral-medium-dark md:block md:max-w-[396px] lg:max-w-[80%]': true,
        }"
      >
        {{ description }}
      </p>
    </div>
  </GeneralLink>
</template>

<script lang="ts" setup>
import GeneralLink from '~/components/Molecules/HeaderComponents/GeneralLink.vue';
import type { CustomerHomeCard } from '~/sanity/types';
defineProps<CustomerHomeCard>();

const { $staticImages } = useNuxtApp();
const rightArrowImageSrc = $staticImages['right-arrow'];
</script>
<style>
.customer-home-card:after {
  background-image: var(--rightArrowImageSrc);
}
</style>
